// oxlint-disable-next-line endla/no-compiler-opt-out -- Existing code
"use no memo";

export const DATA_CY_FILTER_PLOTS = "FilterPlots";

export const DATA_CY_DIAGRAM_TALLIES_SUMMARY = "diagram-tallies-summary";

export const DATA_CY_SET_AS_BUILT_BUTTON = "set-as-built-button";

export const DATA_CY_AS_BUILT_TICK = "as-built-tick";

export const DATA_CY_LAST_DOWNLOAD = "last-download-tick";

export const DATA_CY_CASING_PACKER = "casing-packer";

export const DATA_CY_PACKER_CENTERLINE_DEPTH_INPUT = "packerCenterlineDepthInput";

export const DATA_CY_WELL_PLOT_CONTAINER = "well-plot-container";
export const DATA_CY_WELL_PLOT_SCROLLABLE = "well-plot-scrollable";
export const DATA_CY_WELL_PLOT_CORRELATION_WRAPPER = "well-plot-correlation-wrapper";
export const DATA_CY_WELL_PLOT_CORRELATION_CONTENT = "well-plot-correlation-content";
export const DATA_CY_TRACK_SET = "track-set";
export const DATA_CY_TALLY_PLOT_BODY = "tally-plot-body";
export const DATA_CY_TALLY_PLOT_DEPTH_POINTER_LABEL = "WellPlot-DepthPointer-Label";
export const DATA_CY_WELL_PLOT_BODY = "data-cy-well-plot-body";
export const DATA_CY_CONTEXT_GROUP = "well-plot-grid-row-inspector";
